<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{title}}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <form [formGroup]="inputForm">
      <div class="modal-body">
        <div class="pb-3">
          <h3 class="pb-2">
            {{t("measurements.add.chip.time.title")}} :: {{t("app.common.event")}}
            <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng" [itLabel]="event?.nameIta"
                                 [siLabel]="event?.nameSlo" [bsLabel]="event?.nameBs" [languages]="languages"/>
          </h3>
          <div class="row">
            <div class="col-12 col-xxl-6">
              <div class="d-flex flex-column pt-2 pt-xxl-0">
                <h4 class="pb-2">{{t("measurements.add.chip.instructions.title")}}</h4>
                <ul>
                  <li> {{t("measurements.add.chip.instruction.1")}}
                  </li>
                  <li>
                    {{t("measurements.add.chip.instruction.2")}}
                    <ul>
                      <li>
                        {{t("measurements.add.chip.instruction.2.1")}}
                      </li>
                      <li>
                        {{t("measurements.add.chip.instruction.2.2")}}
                      </li>
                      <li>
                        {{t("measurements.add.chip.instruction.2.3")}}
                      </li>
                    </ul>
                  </li>
                  <li>
                    {{t("measurements.add.chip.instruction.3")}}
                    <ul>
                      <li>
                        {{t("measurements.add.chip.instruction.3.1")}}
                      </li>
                      <li>
                        {{t("measurements.add.chip.instruction.3.2")}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-xxl-6 pt-2 pt-xxl-0">
              <div class="d-flex flex-column">
                <h4 class="pb-3">
                  {{t("measurements.add.chip.instruction.example.title")}}
                </h4>
                <div class="chip-grey-card p-3">
                  <p>
                    {{t("measurements.add.chip.instruction.example.1")}}
                  </p>
                  <p>
                    {{t("measurements.add.chip.instruction.example.2")}}
                  </p>
                  <p>
                    {{t("measurements.add.chip.instruction.example.3")}}
                  </p>
                  <p>
                    {{t("measurements.add.chip.instruction.example.4")}}
                  </p>
                  <p>
                    {{t("measurements.add.chip.instruction.example.5")}}
                  </p>
                  <p>
                    {{t("measurements.add.chip.instruction.example.6")}}
                  </p>
                  <p>
                    {{t("measurements.add.chip.instruction.example.7")}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xxl-3 pb-4">
            <app-select formControlName="raceId" [items]="raceListIds" [translatedLabels]="raceListLabels"
                        [label]="'measurements.controlpoints.race'"/>
          </div>
          <div class="col-12 col-xxl-4">
              <div class="pb-2">
                <app-select formControlName="waypointId" [items]="waypointIds" [translatedLabels]="waypointLabels"
                            [label]="'measurements.measurement.points'"/>
              </div>
          </div>
          <div class="col-12 col-xxl-4">
              <div class="pb-2">
                <app-date-time-input formControlName="date" [displayTime]="false"
                                     [label]="t('app.common.date') | titlecase"/>
              </div>
          </div>
          <div>
            <app-textarea formControlName="chipTime" rows="5"
                          label="race.management.competitors.assign.chip.numbers.input"/>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <div class="me-3">
          <app-button (onClick)="onDismissClick()" [label]="dismissButtonTitle ?? t('app.common.cancel')"
                      [btnClass]="'btn-grey text-uppercase'"></app-button>
        </div>
        <app-button (onClick)="onConfirmClick()" [label]="confirmButtonTitle ?? t('app.common.confirm')"
                    [btnClass]="'btn-primary-red text-uppercase'"
                    [isDisabled]="!inputForm.valid || !inputForm.touched"></app-button>
      </div>
    </div>
  </div>
</ng-container>
